'use client';

import type { ReactNode } from 'react';

import { Text } from '@chakra-ui/react';
import type { SafeLinkProps } from '@/components/ui/SafeLink';
import { SafeLink } from '@/components/ui/SafeLink';

export const MenuItem = ({ children, ...rest }: { children: ReactNode } & SafeLinkProps) => {
  return (
    <Text
      _hover={{ color: 'neutral.50' }}
      asChild
      color="neutral.80"
      fontWeight="regular"
      textStyle="body3"
      transition="color 0.3s"
    >
      <SafeLink {...rest} textDecoration="none">
        {children}
      </SafeLink>
    </Text>
  );
};
